<template>
    <div  :value="value" v-show="showPop">
      <van-popup v-model="showPop" position="bottom" :overlay="true">
        <van-picker
          show-toolbar
          v-model="types"
          :columns="pickerList"
          value-key="name"
          @confirm="typeChange"
          @cancel="showPop = !showPop"
        />
      </van-popup>
    </div>
</template>
<script>
    export default{
        data(){
            return {
              showPop:false,
              pickerList:[
                {
                    name:'请选择',
                    value:''
                }
              ],
              types:'',
              times:1
            }
        },
      props:{
        value:{
          type:Boolean,
          default:false
        },
        typeId:''
      },
      watch:{
        value(val){
          this.showPop = val
        },
        showPop(val){
          this.$emit('input',val)
        },
        typeId(val){
            console.log(val)
            this.types = val
        }
      },
      methods:{
        typeChange(e){
          this.showPop = false
          if(e.value==''){
                return
            }
          this.$emit('typeChange',e)
        },
        getCols(){
            this.$api.getQueryByTcode({
              tcode:'CampaignType'
            }).then(response=>{
               this.pickerList =this.pickerList.concat(response.data)
            })
        }

      },
      created(){
        this.getCols()
      }
    }
</script>
<style scoped lang="less" rel="stylesheet/less">

</style>



// WEBPACK FOOTER //
// src/components/active/component/typePop.vue